  /**
   * Configuração do tenant para o aplicativo Zap GPT
   * Este arquivo define o ID do tenant que será usado em todas as requisições HTTP
   * Altere manualmente o TENANT_ID para gerar builds para diferentes tenants
   */

  export const TENANT_ID = 'default';

  // Configurações de branding da aplicação
  export const APP_NAME = 'Zap GPT';
  export const APP_LOGO_ALT = 'Logo Zap GPT';
  export const APP_WEBSITE = 'https://www.ozapgpt.com.br';

  // Links de suporte e redes sociais
export const SUPPORT_WHATSAPP = 'https://wa.me/5553991774147';
  export const INSTAGRAM_URL = 'https://instagram.com/ozapgpt';
  export const PRICING_URL = 'https://www.ozapgpt.com.br/#pricing';

  // Configurações do Google Calendar
  // IMPORTANTE: Altere essas configurações para usar as credenciais da sua empresa
  export const GOOGLE_CALENDAR_CONFIG = {
    CLIENT_ID: '859648843387-nrg7nofqb6k0feg5kp3hugc9np2og427.apps.googleusercontent.com',
    CLIENT_SECRET: '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',
    REDIRECT_URI: 'https://auth.ozapgpt.com.br/auth/google/callback',
    SCOPES: [
      'https://www.googleapis.com/auth/calendar',
      'https://www.googleapis.com/auth/calendar.events',
      'https://www.googleapis.com/auth/userinfo.email',
      'https://www.googleapis.com/auth/userinfo.profile'
    ],
    AUTH_BASE_URL: 'https://accounts.google.com/o/oauth2/auth'
  };
